import type {
  AttributeInput,
  CartLine,
} from "@shopify/hydrogen-react/storefront-api-types";

type LineItem = Omit<CartLine, "attributes" | "quantity"> & {
  attributes?: AttributeInput[];
  quantity: number;
};

const isLineItem = (line: unknown): line is LineItem =>
  !!line &&
  typeof line === "object" &&
  "id" in line &&
  typeof line.id === "string" &&
  "quantity" in line &&
  typeof line.quantity === "number" &&
  "merchandise" in line &&
  typeof line.merchandise === "object" &&
  "cost" in line &&
  typeof line.cost === "object";

export type { LineItem };
export { isLineItem };
